/* eslint-disable max-len */
export default {
  regionShortName: 'ЯНАО',
  regionFullName: 'Ямало-Ненецкий автономный округ',
  siteDepartment: 'https://dkmns.yanao.ru/',
  systemType: 'ГИС',
  systemTypeFull: 'Государственная информационная система',
  systemShortName: '«АРГИШ',
  systemName: '«АРГИШ»',
  systemFullName:
    'Государственная информационная система по моделированию и прогнозированию социально-экономического развития коренных малочисленных народов Севера Ямало-Ненецкого автономного округа «АРГИШ»',
  systemDescription:
    'Региональная платформа поддержки коренных малочисленных народов Севера разработана для оказания всесторонней помощи и предоставления услуг коренным малочисленным народам Севера Ямало-Ненецкого автономного округа. Наша цель — способствовать социально-экономическому развитию коренных народов, обеспечивать доступ к мерам поддержки и улучшать качество предоставляемых услуг, связанных с жизнью и культурой коренных малочисленных народов Севера в ЯНАО.',
  support: {
    address: '629008, Ямало-Ненецкий автономный округ, Салехард, ул. Гаврюшина, д. 17',
    phone: '+7 (34922) 4-00-72',
    email: "dkmns{'@'}yanao.ru",
    description: 'Написать нам',
  },
  service: {
    filter: {
      organizationName: 'Муниципальное образование',
    },
  },
  svo: {
    columnLabel: 'СВО',
    filterLabel: 'Статус отношения к СВО',
    category: {
      svo: 'Участник СВО',
      family_svo: 'Член семьи участника СВО',
      none: 'Нет данных',
    },
    launchFamilyButton: 'Запросить справку Минобороны по семье',
    launchFamilyConfirm:
      'Будет запущен запрос справки Минобороны по всем совершеннолетним членам семьи. Продолжить?',
    launchFamilySuccess: 'Запрос по семье запущен. Ожидайте завершения в журнале запросов.',
  },
  ttp: {
    ttpTitle: 'ТОЖ',
    newHouseholdSelectLabel: 'район, в котором ведется ТОЖ',
    ttpTitleColumn: 'Территория ведения @:ttp.ttpTitle',
    ttpFullTitle: 'Традиционный образ жизни',
    ttpFullTitleRod: 'Традиционного образа жизни',
    ttpRegistry: 'Реестр ТОЖ',
    householdTitle: 'Семья КМНС',
    householdTitleRod: 'Семьи КМНС',
    householdTitleVin: 'Семью КМНС',
    householdTitlePr: 'Семье КМНС',
    householdTitlePlural: 'Семей КМНС | Семья КМНС | Семьи КМНС',
    householdDelegate: 'Глав семьи | Глава семьи | Главу семьи',
    householdDelegateTv: 'Главой семьи',
    householdNew: 'Новая @:ttp.householdTitle',
    householdCurrent: 'Текущая',
    householdDelegateWithBirthDate: '{fio}, {birthDate} г.р.',
    householdDelegateMissing: 'Глава семьи не указан',
    householdOptionBirthDate: 'Дата рождения:',
    householdOptionBirthDateMissing: 'Дата рождения не указана',
    householdOptionMembersCount: 'Членов семьи: {count}',
    householdEmptyMessage:
      'На выбранной территории отсутствуют семьи КМНС, ведущие традиционный образ жизни',
    communesEmptyMeesage: 'На выбранной территории не зарегистрированы общины',
    addToFamilyWhenCreated: 'Добавить человека в семью?',
    createNewHousehold: 'Новая семья',
    report: {
      statisticsDataDepartmentEveryYear: 'Статистические данные ДКМНС таблица на каждый год',
      finalIndicatorsLegalEntitiesByTypeActivity:
        'Информация из Реестра ТОЖ коренных малочисленных народов Севера регионального значения в ЯНАО',
      demographyReport:
        'Информация по Реестру ТОЖ коренных малочисленных народов Севера регионального значения в ЯНАО по количеству родившихся (включенных) / умерших (исключенных)',
    },
  },
  tmcConflict: {
    title: 'Выписка из реестра ТМЦ',
    openRecord: 'Перейти к ТМЦ',
    familyMember: 'член семьи',
    reasonProvided: '{resource} выдано {date}, {person}, запись №{recordId}',
    reasonQueue: '{resource}, дата постановки {date}, {person}, запись №{recordId}',
    reasonSent: '{resource}, дата отправки уведомления {date}, {person}, запись №{recordId}',
    reasonDraft: '{resource}, дата создания {date}, {person}, запись №{recordId}',
    hintConflict: 'уже существует незакрытая запись',
    hintComposition: 'конфликт состава комплекта',
    hintUsage: 'не прошёл срок использования',
    checkError:
      'Не удалось выполнить проверку реестра материальных средств (заявитель или семья не найдены)',
    noConflicts:
      'Отсутствуют записи в очереди ТМЦ и выданные ранее матсредства, срок пользования которых не истек',
  },
  documents: {
    actionsMenu: 'Действия с файлом',
    preview: 'Предварительный просмотр',
    previewDesc: 'Открыть содержимое файла во всплывающем окне без скачивания',
    download: 'Скачать',
    downloadDesc: 'Сохранить файл на компьютер',
    move: 'Переместить',
    moveDesc: 'Убрать из этой папки и положить в другую',
    copyShortcut: 'Создать ярлык',
    copyShortcutDesc: 'Скопировать ссылку на файл в другую папку',
    removeFromFolder: 'Убрать из папки',
    removeFromFolderDesc: 'Отвязать файл только от этой папки; сам файл останется в системе',
    deletePermanently: 'Удалить навсегда',
    deletePermanentlyDesc: 'Удалить файл из системы целиком. Действие необратимо',
    moveFolder: 'Переместить папку',
    copyFolder: 'Копировать папку',
    confirmRemoveFromFolder:
      'Убрать файл из этой папки? Сам файл останется в системе, если он есть в других местах.',
    confirmDeletePermanently: 'Удалить файл навсегда? Это действие необратимо.',
    deleteBlocked: 'Файл используется в других разделах и не может быть удалён навсегда.',
    folderPicker: {
      current: 'Текущая папка',
      back: 'Назад',
      selectHere: 'Выбрать',
      selectCurrent: 'Выбрать текущую',
      cancel: 'Отмена',
      loading: 'Загрузка папок…',
      moveTitle: 'Выберите папку для перемещения',
      copyTitle: 'Выберите папку для копирования',
      moveFileTitle: 'Выберите папку для перемещения файла',
      linkFileTitle: 'Выберите папку для ярлыка',
      foreignEntityHint: 'В данную папку невозможно перенести/скопировать',
      readonlyHint: 'Папка только для чтения',
      excludedHint: 'Сюда переместить нельзя',
    },
  },
  commissions: {
    protocol: {
      fileHint: 'Файл протокола будет сформирован после утверждения',
      regenerate: 'Сформировать заново',
      regenerateConfirm: 'Сгенерированный файл будет заменён. Продолжить?',
    },
  },
  userActivityStatistics: {
    pageTitle: 'Статистика активности',
    loginPageTitle: 'Статистика по пользователям системы',
    issuePageTitle: 'Статистика по поданным заявлениям',
    menuLogins: 'Пользователи',
    menuIssues: 'Заявления',
    viewTable: 'Таблица',
    viewChart: 'График',
    fromDate: 'Начало периода, день включительно',
    toDate: 'Конец периода, день включительно',
    intervalDay: 'по дням',
    intervalWeek: 'по неделям',
    intervalMonth: 'по месяцам',
    roles: 'Роли',
    services: 'Услуги',
    apply: 'Применить',
    reset: 'Сбросить',
    export: 'Экспорт',
    loginChartTitle: 'Число уникальных авторизаций пользователей системы',
    issueChartTitle: 'Поданные заявления по услугам',
    noChartData: 'Нет данных для графика за выбранный период',
    submittedUserSeries: 'При помощи портала или ЕПГУ',
    hints: {
      interval: 'Как сгруппировать строки?',
    },
    columns: {
      period: 'Период',
      role: 'Роль',
      countUser: 'Уникальные пользователи',
      service: 'Услуга',
      countIssue: 'Количество заявлений',
      countSubmittedUser: 'При помощи портала или ЕПГУ',
    },
  },
  reportForms: {
    downloadTemplate: 'Скачать шаблон',
    uploadTemplate: 'Имопортировать из шаблона',
    templateDialogTitle: 'Скачать шаблон',
    templateFormat: 'Формат файла',
    templateFormatHint: 'Файл XLSX или CSV. Не меняйте служебные строки и структуру таблицы.',
    download: 'Скачать',
    cancel: 'Отмена',
    formatXlsx: 'XLSX',
    formatCsv: 'CSV',
    sign: 'Подписать',
    signAgain: 'Подписать заново',
    signDialogTitle: 'Выбор сертификата',
    signRequired: 'Перед отправкой на проверку подпишите отчёт УКЭП',
    resignConfirm:
      'Сформировать файл заново? Текущая подпись перестанет относиться к этому отчёту.',
    noCertificatesLead: 'У вас нет сертификатов для подписания. Добавьте их в разделе ',
    noCertificatesLink: '«Мои сертификаты»',
    selectCertificate: 'Выберите сертификат, который хотите использовать',
    signCertificatesLoading: 'Загрузка сертификатов. Подтвердите доступ к плагину, если браузер запросит.',
    attachment: 'Приложение (необязательно)',
    attachmentPlaceholder: 'Прикрепить файл',
    attachmentSaved: 'Приложение прикреплено',
    fillTab: 'Заполнение',
    multiPeriodSummary: 'Свод по нескольким периодам',
  },
};
